export default function() {
  const userAgent = navigator.userAgent
  const isMacOS = userAgent.includes("Macintosh") || userAgent.includes("Mac OS X")
  const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent)

  return isMacOS && isSafari
}
